import { __decorate } from "tslib";
import { VuexModule, Module, Mutation, getModule, Action } from 'vuex-module-decorators';
import store from '@blade/common/store';
import { getSearchType } from '@blade-sxp/search-center/api/index';
let searchCenter = class searchCenter extends VuexModule {
    linkList = []; // 事件下拉框
    tabList = []; // tab 标签
    tabActive = ''; // tab标签选中
    featureList = [];
    attributesObj = {};
    selectedImg = [];
    async getEventType() {
        try {
            return await getSearchType({ key: 'searchCenter' }).then((res) => res);
        }
        catch (e) {
            throw e;
        }
    }
    async getSearchType() {
        try {
            return await getSearchType({ key: 'searchTypeAlgorithm' }).then((res) => res);
        }
        catch (e) {
            throw e;
        }
    }
    updateTab(tab) {
        this.tabList = tab;
    }
    updateTabActive(tab) {
        this.tabActive = tab;
    }
    updateFeatureList(featureList) {
        this.featureList = featureList;
    }
    updateAttributes(value) {
        this.attributesObj = value;
    }
    updateSelectedImg(data) {
        this.selectedImg = data;
    }
};
__decorate([
    Action({ rawError: true })
], searchCenter.prototype, "getEventType", null);
__decorate([
    Action({ rawError: true })
], searchCenter.prototype, "getSearchType", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateTab", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateTabActive", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateFeatureList", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateAttributes", null);
__decorate([
    Mutation
], searchCenter.prototype, "updateSelectedImg", null);
searchCenter = __decorate([
    Module({ dynamic: true, store, namespaced: true, name: 'senseXplorer/search' })
], searchCenter);
export const searchStore = getModule(searchCenter);
